<template>
  <ul class="language-switcher">
    <li class="title">{{ $t('languages.language') }}</li>
    <li
      v-for="lang in languages"
      :key="lang.code"
      :class="language === lang ? 'active' : ''"
      @click="setLanguage(lang)">{{ $t(lang.name) }}</li>
  </ul>
</template>

<script>
import { UPDATE_LANGUAGE } from '@/store/actions.type'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'AppNav',
  myTimeout: null,
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['language']),
    ...mapState({ languages: state => state.language.languages })
  },
  methods: {
    setLanguage(lang) {
      this.$store.dispatch(UPDATE_LANGUAGE, lang.code)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.language-switcher {
  font-weight: 300;
  list-style-type: none;
  margin: 0;
  padding: 0;

  li {
    cursor: pointer;
    margin: 0;
    padding: 0;
  }

  .active {
    color: #35BDD1;
    font-weight: 600;
  }
}
</style>
